import { useState, useEffect } from "react";
import { translateText } from "../utils/translator";

export function useTranslatedText(text, lanText) {
    const [translated, setTranslated] = useState(text);

    useEffect(() => {
        if (!text) return;
        let cancelled = false;

        translateText(text, lanText).then((result) => {
            if (!cancelled) setTranslated(result);
        });

        return () => { cancelled = true; };
    }, [text, lanText]);

    return translated;
}